// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","Badge":"_2mnaMB","fadeInFrames":"pHcro2"};